/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  careCuesSlice,
  navigationSlice,
  selectedDateSlice,
  selectedVisitSlice,
  templatesSlice,
  mixpanelSlice,
  noteSlice,
  authSlice,
  providerSlice,
  appSlice,
  noteReviewSlice,
  adminSlice,
  visitsSlice,
} from './storeFeatures';

let middleware: any[] = [];

const isDevelopment = process.env.NODE_ENV === 'development';
const isTest = process.env.NODE_ENV === 'test';
if (isDevelopment || isTest) {
  middleware = [...middleware];
}

const rootReducers = {
  selectedVisit: selectedVisitSlice.reducer,
  selectedDate: selectedDateSlice.reducer,
  templates: templatesSlice.reducer,
  careCues: careCuesSlice.reducer,
  navigation: navigationSlice.reducer,
  mixpanel: mixpanelSlice.reducer,
  note: noteSlice.reducer,
  auth: authSlice.reducer,
  provider: providerSlice.reducer,
  app: appSlice.reducer,
  noteReview: noteReviewSlice.reducer,
  admin: adminSlice.reducer,
  visits: visitsSlice.reducer,
};

export { middleware, rootReducers };
